import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DataService } from '@app-core/services/data/data.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
})
export class SelectComponent implements OnChanges, OnInit, OnDestroy {
  @Input()
  public form: FormGroup;
  @Input()
  public config: any = {};
  public currentMetricUnit = null;
  public ngUnsubscribe: Subject<void> = new Subject<void>();
  @Input() public isDisabled: boolean;
  constructor(private dataService: DataService) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if ((changes['isDisabled'] || changes['form']) && this.form && this.config?.key) {
      const control = this.form.get(this.config.key);
      if (control) {
        this.isDisabled ? control.disable() : control.enable();
      }
    }
  }

  public ngOnInit() {
    this.dataService._currentMetricUnit.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value: string) => {
      if (value) {
        this.currentMetricUnit = value;
      }
    });
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
